import { useEffect, useState } from 'react';

const ICONS = {
  success: (
    <svg className="w-5 h-5" fill="none" 
      stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" 
        strokeLinejoin="round" strokeWidth={2} 
        d="M5 13l4 4L19 7" />
    </svg>
  ),
  error: (
    <svg className="w-5 h-5" fill="none" 
      stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" 
        strokeLinejoin="round" strokeWidth={2} 
        d="M6 18L18 6M6 6l12 12" />
    </svg>
  ),
  info: (
    <svg className="w-5 h-5" fill="none" 
      stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" 
        strokeLinejoin="round" strokeWidth={2} 
        d="M13 16h-1v-4h-1m1-4h.01M21 
        12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  ),
  warning: (
    <svg className="w-5 h-5" fill="none" 
      stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" 
        strokeLinejoin="round" strokeWidth={2} 
        d="M12 9v2m0 4h.01m-6.938 
        4h13.856c1.54 0 2.502-1.667 
        1.732-3L13.732 4c-.77-1.333-2.694
        -1.333-3.464 0L3.34 16c-.77 
        1.333.192 3 1.732 3z" />
    </svg>
  ),
};

const STYLES = {
  success: 'bg-white border-l-4 border-[#d4af37] text-gray-800',
  error: 'bg-white border-l-4 border-red-500 text-gray-800',
  info: 'bg-white border-l-4 border-blue-500 text-gray-800',
  warning: 'bg-white border-l-4 border-yellow-500 text-gray-800',
};

const ICON_COLORS = {
  success: 'text-[#d4af37]',
  error: 'text-red-500',
  info: 'text-blue-500',
  warning: 'text-yellow-500',
};

export default function Toast({ 
  id, message, type, duration, onRemove }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Slide in
    setTimeout(() => setVisible(true), 10);
    // Slide out before removal
    const slideOut = setTimeout(() => 
      setVisible(false), duration - 300);
    return () => clearTimeout(slideOut);
  }, [duration]);

  return (
    <div
      className={`
        flex items-start gap-3 p-4 rounded-lg 
        shadow-lg min-w-[300px] max-w-[400px]
        transition-all duration-300 cursor-pointer
        ${STYLES[type]}
        ${visible 
          ? 'opacity-100 translate-x-0' 
          : 'opacity-0 translate-x-full'}
      `}
      onClick={() => onRemove(id)}
    >
      <span className={`mt-0.5 flex-shrink-0 
        ${ICON_COLORS[type]}`}>
        {ICONS[type]}
      </span>
      <p className="text-sm font-medium 
        flex-1 leading-relaxed">
        {message}
      </p>
      <button
        onClick={() => onRemove(id)}
        className="text-gray-400 hover:text-gray-600 
          flex-shrink-0 ml-2"
      >
        <svg className="w-4 h-4" fill="none" 
          stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" 
            strokeLinejoin="round" strokeWidth={2} 
            d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
}
